import { render, staticRenderFns } from "./SubBrandForm.vue?vue&type=template&id=47c12630&"
import script from "./SubBrandForm.vue?vue&type=script&lang=js&"
export * from "./SubBrandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports